import { CodeMap } from 'adminConsole/codeMap'
import { service } from './service'
import { errorHandler } from 'share/util/common'

export const emptyCodeMap = {
  id: 0,
  category: '',
  precedence: 100,
  name: '',
  value: '',
  enable: true,
  reserve1: null,
  reserve2: null,
}

class CodeMapStroe {
  private _codeMapList: CodeMap[] = []

  private _codeMap: CodeMap = { ...emptyCodeMap }

  get codeMapList() {
    return this._codeMapList
  }
  get codeMap() {
    return this._codeMap
  }

  getCodeMapList = async () => {
    const res = await service.getCodeMapList()

    if (!res.ok) await errorHandler(res)

    this._codeMapList = await res.json()
  }

  getCodeMapById = async (id: number) => {
    const res = await service.getCodeMapById(id)

    if (!res.ok) await errorHandler(res)

    this._codeMap = await res.json()
  }

  addCodeMap = async (data: Partial<CodeMap>) => {
    const res = await service.addCodeMap(data)

    if (!res.ok) await errorHandler(res)
  }

  updateCodeMap = async (data: Partial<CodeMap>) => {
    const res = await service.updateCodeMap(data)

    if (!res.ok) await errorHandler(res)
  }

  deleteCodeMap = async (id: number) => {
    const res = await service.deleteCodeMap(id)

    if (!res.ok) await errorHandler(res)
  }
}

export const codeMapStore = new CodeMapStroe()
